// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import DocumentMeta from 'react-document-meta'
import { Link } from 'react-router-dom'
import { Waypoint } from 'react-waypoint'

// Internal Dependencies:
import HomePageHeaderVideo from './HomePageHeaderVideo'
import NewsletterModal from 'components/NewsletterModal/NewsletterModal'
import MediaPlayer from 'components/MediaPlayer/MediaPlayer'

// Redux:
import * as reduxSite from 'actions/site'

class Home extends React.Component {
	constructor() {
		super()

		this.state = {
			showNewsletterModal: false,
			faqs: [
				{
					title: 'What is the Animation Coop?',
					content: `
						<p>The Animation Coop is an online animation studio that will produce cartoons and other media for the Australian Union Conference of the Seventh-day Adventist Church.</p>
						<p>We are seeking creative volunteers from across Australia to help us produce this content.</p>
					`
				},
				{
					title: 'What are the cartoons about?',
					content: `<p>The story of Daniel. Daniel was taken from his home as a teenager never to return. He lost his name and identity in a foreign land, and had to survive under a cruel dictator.</p>`
				},
				{
					title: 'What do I get?',
					content: `<p>Free training from a professional animator, access to a supportive creative community, and real-life experience in animation production.</p>`
				},
				{
					title: 'But I can’t animate!',
					content: `<p>Fine! We will teach you. Training videos will be posted online at animationcoop.org.au. Over time we will have a whole animation course online.</p>`
				},
				{
					title: 'But I can’t draw!',
					content: `<p>To be good at drawing (like anything) takes a lot of practice. Keep at it. We will post training videos starting from the basics and give constructive feedback to help you improve your illustration skills.</p>`
				},
				{
					title: 'No really! I can’t draw!',
					content: `<p>We also need people interested in sound, music, colour, design, drama and technology. Animation productions require technically-minded people to make animation tools such as digital puppets and oversee production.</p>`
				},
				{
					title: 'This sounds great, but I live out the back of Whoop Whoop.',
					content: `<p>If you have an Internet connection, then you can be part of our team. You can learn to animate using free open source animation software.</p>`
				},
				{
					title: 'This sounds like it is for old/young/whatever people.',
					content: `
						<p>This online collaboration is open to people of any age, race, gender, ability or belief. We want to support anyone who would love to be part of our team.</p>
						<p>The Bible says that we are made in God’s image and He is the ultimate creative genius (Genesis 1:27). Why not take this opportunity to develop and discover your creative potental?</p>
					`
				},
				{
					title: 'Can I just do the training?',
					content: `<p>Sure! However, getting involved and being committed will turbocharge your growth in mastering your craft.</p>`
				}
			]
		}
	}

	showNewsletterModal = () => {
		this.setState( {
			showNewsletterModal: true
		} )
	}

	hideNewsletterModal = () => {
		const { dispatch } = this.props

		this.setState( {
			showNewsletterModal: false
		} )

		dispatch( reduxSite.hasDismissedNewsletterModal() )
	}

	render() {
		const { match, location, hasDismissedNewsletterModal } = this.props
		const { showNewsletterModal, faqs } = this.state

		return (
			<div className="page-home">
				{ ( showNewsletterModal && ! hasDismissedNewsletterModal ) &&
					<NewsletterModal cancel={ this.hideNewsletterModal } />
				}

				<HomePageHeaderVideo />
				{/*<div className="home-header" />*/}

				<div className="section-text-a">
					<div className="-inner">
						<div className="-text">
							<div className="-text-primary">
								<h2>Who we are</h2>

								<p>
									The Animation Coop is a volunteer-based online community that is focussed on creating animation, sound and other visual media. The objective of this community is to produce animated short films, video and other media for the Australian Union Conference of the Seventh-day Adventist Church.
								</p>
							</div>

							<div className="-image">
								<img src={ `${siteData.images_url}home/video-1-overlay.png` } alt="" />
							</div>

							<div className="-text-secondary">
								<p>
									The set project will require volunteer staff from across the continent to contribute their time in an online collaboration.
								</p>

								<p>
									The Animation Coop name is reminiscent of a farmer’s cooperative. According to the <a href="https://www.ica.coop/en/cooperatives/what-is-a-cooperative" target="_blank" rel="noopener">International Co-operative Alliance</a>: “Cooperatives are people-centred enterprises owned, controlled and run by and for their members to realise their common economic, social, and cultural needs and aspirations.”
								</p>
							</div>
						</div>
					</div>
				</div>

				<div className="section-text-b">
					<div className="-image">
						<img src={ `${siteData.images_url}home-header/Dan_Ch02_Sc01_Sh05_BG_HD.jpg` } alt="" />
					</div>

					<div className="-inner">
						<div className="-text">
							<h2>Idea &amp; Mission</h2>

							<p>
								The purpose of this project is to produce a suite of effective contemporary evangelistic materials that point to Jesus Christ and the promise of his return. Specifically, the objective is to accomplish the following:
							</p>

							<ul>
								<li>Produce a transmedia storytelling of the Old Testament book of Daniel,</li>
								<li>Through the assistance of an online creative community</li>
							</ul>
						</div>
					</div>
				</div>

				<div className="section-text-a">
					<div className="-inner">
						<div className="-text">
							<div className="-text-primary">
								<h2>Helping Youth to Explore, Grow, & Learn</h2>

								<p>
									This transmedia project can only be brought to fruition with the help of creative volunteers – many who will have had no previous experience with animation or media production.
								</p>
							</div>

							<div className="-image">
								<img src={ `${siteData.images_url}home/video-1-overlay-b.png` } alt="" />
							</div>

							<div className="-text-secondary">
								<p>
									The Animation Coop will develop a large volunteer production staff through the following process.
								</p>

								<ul>
									<li>Establishment and facilitation of a creative community. A safe virtual space where people of all ages and backgrounds can come together and network around shared creative interests.</li>
									<li>The Animation Coop will offer a free training curriculum on animation production to interested participants.</li>
									<li>Through involvement with this community and completion of the animation curriculum participants gain the confidence to post examples of their own work for encouragement and constructive critiques.</li>
									<li>Participants who want to get further experience within their creative field are encouraged to sign up for the transmedia production crew.</li>
									<li>Production roles are allocated to participants with regards to their personal interests and ability as seen by work that has been posted within the community</li>
									<li>Work is assigned to volunteers via a virtual animation production platform. This platform is used to review and receive completed work.</li>
									<li>Finished media is rendered, edited and composited at the AUC head office and uploaded for public viewing.</li>
								</ul>

								<p>
									There is potential for indirect evangelism toward volunteers by way of a supportive caring church community encouraging people to be creative communicators. A safe space where creativity is seen as a spiritual practice i.e., God creates, Humanity is made in the image of God (Genesis 1:27) therefore when we create, we give glory to God.
								</p>

								<p>
									As participants are involved in the transmedia production, they will be encouraged to study the relevant stories and Bible passages. It is anticipated that an extended exposure to these stories and the spiritual meaning behind them will be a positive influence on production volunteers.
								</p>
							</div>
						</div>
					</div>
				</div>

				<Waypoint
					onEnter={ () => {
						this.showNewsletterModal()
					} }
				/>

				<div className="section-video">
					<div className="-inner">
						<MediaPlayer file={ `${siteData.videos_url}animationcoop_promo_hd.mp4` } thumb_url={ `${siteData.videos_url}animationcoop_promo_hd_thumb.jpg` } />
					</div>
				</div>

				<div className="section-chickens-grid">
					<div className="-inner">
						<div className="-text">
							<h2>Which kind of creative are you?</h2>
						</div>

						<div className="-images-wrap">
							<div className="-images">
								<Link to="/contact?type=sketch" className="-image">
									<img src={ `${siteData.images_url}chickens-grid/write.jpg` } alt="" />

									<span className="-image-text">Sketch artist</span>
								</Link>

								<Link to="/contact?type=sound" className="-image">
									<img src={ `${siteData.images_url}chickens-grid/sound.jpg` } alt="" />

									<span className="-image-text">Sound artist</span>
								</Link>

								<Link to="/contact?type=technical" className="-image">
									<img src={ `${siteData.images_url}chickens-grid/computer.jpg` } alt="" />

									<span className="-image-text">Technical</span>
								</Link>

								<Link to="/contact?type=voice" className="-image">
									<img src={ `${siteData.images_url}chickens-grid/speak.jpg` } alt="" />

									<span className="-image-text">Voice actor</span>
								</Link>

								<Link to="/contact?type=general" className="-image">
									<img src={ `${siteData.images_url}chickens-grid/logo.jpg` } alt="" />

									<span className="-image-text">?</span>
								</Link>

								<Link to="/contact?type=music" className="-image">
									<img src={ `${siteData.images_url}chickens-grid/music.jpg` } alt="" />

									<span className="-image-text">Musician</span>
								</Link>

								<Link to="/contact?type=animator" className="-image">
									<img src={ `${siteData.images_url}chickens-grid/draw.jpg` } alt="" />

									<span className="-image-text">Animator</span>
								</Link>

								<Link to="/contact?type=general" className="-image">
									<img src={ `${siteData.images_url}chickens-grid/read.jpg` } alt="" />

									<span className="-image-text">?</span>
								</Link>

								<Link to="/contact?type=general" className="-image">
									<img src={ `${siteData.images_url}chickens-grid/chicken.jpg` } alt="" />

									<span className="-image-text">?</span>
								</Link>
							</div>
						</div>
					</div>
				</div>

				<div className="section-faqs">
					<div className="-inner">
						<div className="-text">
							<div className="-text-primary">
								<h2>FAQs</h2>
							</div>

							<div className="-image">
								<img src={ `${siteData.images_url}home/take-me-to-king.jpg` } alt="" />
							</div>

							<div className="-text-secondary">
								{ faqs.map( ( item, i ) => {
									return (
										<div className="accordion-section is-not-active" key={ i }>
											<div className="accordion-title"><span>{ item.title }</span> <i></i></div>

											<div className="accordion-content" dangerouslySetInnerHTML={ { __html: item.content } } />
										</div>
									)
								} ) }
							</div>
						</div>
					</div>
				</div>

				<div className="section-newsletter">
					<div className="-inner">
						<div className="-envelope">
							<div className="-paper">
								<h4>Let’s keep in touch.</h4>

								<form action="https://adventist.us14.list-manage.com/subscribe?u=a2d3ed8e193e59235f48acdb2&id=6257feeee2" method="post" target="_blank">
									<div className="form-item">
										<input type="text" name="MERGE1" placeholder="Your name" />
									</div>

									<div className="form-item">
										<input type="email" name="MERGE0" placeholder="Your email" />
									</div>

									<div className="form-item">
										<button className="button" type="submit" name="subscribe">Subscribe</button>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>

			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		hasDismissedNewsletterModal: state.site.hasDismissedNewsletterModal
	}
}

export default connect( mapStateToProps )( Home )



// WEBPACK FOOTER //
// ./views/pages/home/Home.jsx